import { EditorialQuote } from '../types/editorial-quote.type';
import { EditorialStep } from '../types/editorial-step.type';

import groupOrderIllustration from '../../assets/img/sacs.png';
import carbonIllustration from '../../assets/img/co2.png';
import ecoPointsIllustration from '../../assets/img/eco.png';
import lorenePortrait from '../../assets/img/client1.png';
import pierrePortrait from '../../assets/img/client2.png';
import mariannePortrait from '../../assets/img/client3.png';
import sylviePortrait from '../../assets/img/client4.png';

// Contenu relevé sur la page legacy /eco-points (src/views/Front/EcoActeurs/EcoPoints.js), dont
// tous les titres sont écrits en minuscules.
export const ECO_POINTS_HERO = {
  title: 'Éco-points et témoignages',
  highlight: 'Sur chaque achat groupé, 10 % de la somme vous est redistribuée en éco-points.',
};

export const ECO_POINTS_EXAMPLE = {
  title: 'Par exemple',
  // Une vraie succession : on réunit, puis on reçoit, puis on dépense.
  steps: [
    { label: 'Vous réunissez pour 320 € de commande' },
    { label: 'Vous recevez 32 éco-points, équivalents à 32 €', operator: '>' },
    { label: 'Faites-vous plaisir, ou faites un don à une banque alimentaire', operator: '>' },
  ] as EditorialStep[],
};

export const ECO_POINTS_EQUATION = {
  title: 'Amusez-vous, partagez',
  steps: [
    {
      label: 'Une commande groupée',
      illustration: groupOrderIllustration,
      illustrationAlt: 'Des sacs de commande groupée',
    },
    {
      label: 'Moins de CO2',
      operator: '=',
      illustration: carbonIllustration,
      illustrationAlt: 'Un nuage de CO2 barré',
    },
    {
      label: 'Des éco-points',
      operator: '=',
      illustration: ecoPointsIllustration,
      illustrationAlt: 'Le pictogramme des éco-points',
    },
  ] as EditorialStep[],
  ctaLabel: 'Devenir éco-acteur',
  // La page Devenir éco-acteur n'existe pas encore sous /v2 : le bouton s'affiche sans naviguer.
  ctaPath: null as string | null,
};

export const ECO_POINTS_TESTIMONIALS_TITLE = 'Témoignages';

export const ECO_POINTS_TESTIMONIALS: EditorialQuote[] = [
  {
    quote:
      'Je prends 5 minutes de mon temps tous les lundis pour lancer mon invitation aux collègues de la société. Bio Culture me livre le jeudi matin, et les consom’acteurs récupèrent leur commande entre 14 h et 15 h dans mon bureau, ou celui de ma collègue quand je ne peux pas. Grâce aux Eco-Points, nous bénéficions d’une corbeille de fruits bio chaque semaine, livrée avec nos paniers. Le tout financé par nos achats à tous !',
    author: 'Lorène',
    role: 'Assistante de direction',
    portrait: lorenePortrait,
    portraitAlt: 'Lorène, assistante de direction',
  },
  {
    quote:
      'Depuis 6 ans je commande chez Bio Culture pour leurs produits et leur service. J’ai testé une première distribution de paniers, surtout pour rendre service à la petite mamie d’à côté de chez moi qui a des problèmes de mobilité. Nous sommes désormais 6 foyers à nous faire livrer chaque semaine ! Et mon action est récompensée : 1 commande sur 3 est gratuite grâce aux Eco-Points.',
    author: 'Pierre',
    role: 'Client historique de Bio Culture',
    portrait: pierrePortrait,
    portraitAlt: 'Pierre, client historique de Bio Culture',
  },
  {
    quote:
      'J’organise un achat groupé à la crèche chaque vendredi. Les parents récupèrent leur panier en même temps que leur enfant. On leur a facilité la vie et on a fait évoluer leurs habitudes alimentaires. Mes collègues en profitent aussi. Nous utilisons nos Eco-Points pour être livrés chaque semaine d’une cagette de fruits bio pour nos petits loups. Ainsi, l’achat des parents profite directement aux enfants !',
    author: 'Marianne',
    role: 'Directrice de crèche',
    portrait: mariannePortrait,
    portraitAlt: 'Marianne, directrice de crèche',
  },
  {
    quote:
      'L’achat responsable, les bons produits, le respect de la terre ont toujours fait partie de mes convictions. Je partage désormais ces valeurs avec mon entourage : mes amis, mes voisins. À chaque distribution, nous échangeons sur les recettes de la semaine précédente, sur les nouvelles saveurs. En plus de mes Eco-Points, je reçois des paniers « découvertes » de Bio Culture, l’occasion d’en faire profiter mon entourage.',
    author: 'Sylvie',
    role: 'Femme de son temps, maman de 2 enfants',
    portrait: sylviePortrait,
    portraitAlt: 'Sylvie, maman de deux enfants',
  },
];
